import { connect } from 'react-redux';
import { selectRouteParams } from 'selectors/general';

import ServicesListItem from './ServicesListItem';

const mapStateToProps = (state, ownProps) => {
  const { itemId } = selectRouteParams(state);
  return {
    ...ownProps,
    selectedServiceId: itemId,
  };
};

export default connect(mapStateToProps)(ServicesListItem);
